import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Simulacio } from 'src/app/models/simulacio.model';
import { RumiService } from 'src/app/services/rumi.service';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  constructor(
    public translate: TranslateService,
    private router: Router,
    public modal: ModalService,
    private rumiService: RumiService
  ) { }

  ngOnInit() { }

  goToSimulacio() {
    if(this.rumiService.simulacio == null){
      this.rumiService.simulacio = new Simulacio();
    }
    this.router.navigate([this.rumiService.pestanyaActiva]);
  }

}
